import React, { useEffect, useState } from "react";
import axiosClient from "../../../../../config/axios.js";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import { useAuth } from "../../../../../context/AuthContext.js";

function TypesVehicles() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState("id");
  const [sortDirection, setSortDirection] = useState("asc");

  const deleteVehicleType = (id) => {
    Swal.fire({
      title: "¿Está seguro que desea borrar el tipo de vehículo seleccionado?",
      text: "Una vez eliminado, no podrá recuperarlo.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axiosClient
          .delete(`/vehicleTypes/delete/${id}`)
          .then((response) => {
            fetchData();
            Swal.fire(
              "Eliminado",
              "El tipo de vehículo se ha borrado exitosamente.",
              "success"
            );
          })
          .catch((err) => {
            console.error(err);
            Swal.fire(
              "Error",
              "No se pudo eliminar el tipo de vehículo.",
              "error"
            );
          });
      }
    });
  };

  const fetchData = async (
    currentPage = 1,
    search = "",
    sortField,
    sortDirection
  ) => {
    try {
      const response = await axiosClient.get(`/vehicleTypes/datatable`, {
        params: {
          start: (currentPage - 1) * rowsPerPage,
          length: rowsPerPage,
          search: search,
          sort: sortField,
          dir: sortDirection,
        },
      });
      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchData(currentPage, searchValue, sortField, sortDirection);
  }, [currentPage, rowsPerPage, sortField, sortDirection]);

  const columns = [
    { name: "ID", selector: (row) => row.id, sortable: true, sortField: "id" },
    {
      name: "Tipo de Vehículo",
      selector: (row) => row.vehicle_type_name,
      sortable: true,
      sortField: "vehicle_type_name",
    },
    {
      name: "Visible",
      selector: (row) => (row.is_visible ? "Visible" : "No visible"),
      sortable: true,
      sortField: "is_visible",
      cell: (row) => (
        <span
          className={`badge ${row.is_visible ? "bg-success" : "bg-secondary"}`}
        >
          {row.is_visible ? "Visible" : "No visible"}
        </span>
      ),
    },
    {
      name: "Editar",
      button: true,
      cell: (row) => (
        <Link to={`/catalogs/vehicleTypes/edit/${row.id}`}>
          <i className="fa fa-pencil" />
        </Link>
      ),
    },
    {
      name: "Eliminar",
      button: true,
      cell: (row) => (
        <a href="#" onClick={() => deleteVehicleType(row.id)}>
          <i className="fa fa-trash" />
        </a>
      ),
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        color: "#202124",
        fontSize: "14px",
        backgroundColor: "#EEEEEE",
        border: "none",
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: false,
    selectAllRowsItemText: "Todos",
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setLoading(true);
      setCurrentPage(1);
      fetchData(currentPage, searchValue, sortField, sortDirection);
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <h1 className="page-header mb-0">Tipos de Vehículos</h1>
        </div>
        <div className="ms-auto">
          <Link
            to={"/catalogs/vehicleTypes/new"}
            className="btn btn-success btn-rounded px-4 rounded-pill"
          >
            <i className="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i>
            Nuevo Tipo
          </Link>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <DataTable
            title=""
            className="table"
            columns={columns}
            data={data.data}
            progressPending={loading}
            sortServer
            pagination
            paginationServer
            paginationPerPage={rowsPerPage}
            paginationTotalRows={data.recordsTotal}
            paginationDefaultPage={currentPage}
            subHeader
            customStyles={customStyles}
            pointerOnHover
            paginationComponentOptions={paginationComponentOptions}
            noDataComponent="Sin información por mostrar"
            progressComponent={
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Cargando...</span>
              </Spinner>
            }
            subHeaderComponent={
              <div className="row">
                <div className="col-sm-12 col-md-12">
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Buscar..."
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                      onKeyPress={handleKeyPress}
                    />
                    <div
                      className="input-group-text btn btn-info"
                      onClick={() => {
                        setLoading(true);
                        setCurrentPage(1);
                        fetchData(
                          currentPage,
                          searchValue,
                          sortField,
                          sortDirection
                        );
                      }}
                    >
                      <i className="fa fa-search"></i>
                    </div>
                  </div>
                </div>
              </div>
            }
            onChangePage={(page) => setCurrentPage(page)}
            onChangeRowsPerPage={(newPerPage) => {
              setRowsPerPage(newPerPage);
              setCurrentPage(1);
            }}
            onSort={(column, sortDirection) => {
              setSortDirection(sortDirection);
              setSortField(column.sortField);
              setLoading(true);
              setCurrentPage(1);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default TypesVehicles;
